import "./CalculationResult.css";


function priceFormat(number) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
        number,
    );
}
function CalculationResult({formData}) {
    const taxRate = formData.taxPercent / 100;
    let totalCarValue = formData.msrp * taxRate + formData.msrp + formData.feeValue;

    let monthlyPayment = 0;
    let totalFinanceInterest = 0;
    if (formData.paymentType === 'finance') {
        const monInt = formData.financeApr / 1200;
        monthlyPayment = ((monInt + (monInt / (Math.pow((1 + monInt), formData.financeLength) -1))) * (totalCarValue - formData.financeDownPayment)).toFixed(2);
        totalFinanceInterest = monthlyPayment * formData.financeLength - (totalCarValue - formData.financeDownPayment);
    }
    totalCarValue += totalFinanceInterest;

    const leaseCarValue = formData.leasingDownPayment + formData.leasingMonthlyPayment * formData.leasingLength;
    const leaseCarTotal = formData.feeValue + leaseCarValue * taxRate + leaseCarValue;

    const lossIfPurchase = totalCarValue - formData.usedCarPrice;
    const lossIfLease = leaseCarTotal;


    let financeResult = '';
    if (formData.paymentType === 'finance') {
        financeResult = (<>
            <b>Данные по кредиту</b><br/>
            Переплата по кредиту составляет: <b>{priceFormat(totalFinanceInterest)}</b> <br/>
            Ежемесячный платеж по кредиту: <b>{priceFormat(monthlyPayment)}</b> <br/><br/>
        </>);
    }


    return (
        <div className="Result">
            Обшая стоимость машины при покупке (Car price + taxes + fees): <b>{priceFormat(totalCarValue)}</b> <br/>
            Стоимость после {formData.leasingLength} месяцев: <b>{priceFormat(formData.usedCarPrice)}</b><br/>
            То есть после {formData.leasingLength} месяцев потеря на покупке составит: <b>{priceFormat(lossIfPurchase)}</b>
            <br/><br/>
            Общая стоимость лизинга / потеря на лизинге (down payment + lease payments + taxes +
            fees: <b>{priceFormat(leaseCarTotal)}</b><br/><br/>
            {financeResult}
            Вывод: <b>{lossIfPurchase > lossIfLease ? "лизинг выгоднее на " + priceFormat(lossIfPurchase - lossIfLease)
            : "покупка выгоднее на " + priceFormat(lossIfLease - lossIfPurchase)}</b>
        </div>
    );
}

export default CalculationResult;